import React from 'react';
import { Tabs, Tab } from '@material-ui/core';

type StatusFilterValue = 'active' | 'inactive' | 'all';

interface StatusFilterTabsProps {
  value: StatusFilterValue;
  onChange: (value: StatusFilterValue) => void;
  counts?: {
    active?: number;
    inactive?: number;
    all?: number;
  };
}

const StatusFilterTabs: React.FC<StatusFilterTabsProps> = ({
  value,
  onChange,
  counts
}) => {
  const handleChange = (
    _event: React.ChangeEvent<{}>,
    newValue: StatusFilterValue
  ) => {
    onChange(newValue);
  };

  const renderLabel = (label: string, count?: number) => {
    if (count !== undefined) {
      return `${label} (${count})`;
    }
    return label;
  };

  return (
    <Tabs
      value={value}
      onChange={handleChange}
      indicatorColor="primary"
      textColor="primary"
      aria-label="Status filter tabs"
      style={{ marginBottom: 16 }}
    >
      <Tab label={renderLabel('Active', counts?.active)} value="active" />
      <Tab label={renderLabel('Inactive', counts?.inactive)} value="inactive" />
      <Tab label={renderLabel('All', counts?.all)} value="all" />
    </Tabs>
  );
};

export default React.memo(StatusFilterTabs);
